import { Locale, type LocalizedString } from "../Locale.js";
import type { Tenant } from "../Tenant.js";
import { getPathInLocale } from "./getPathInLocale.js";

const pathMap = {
	[Locale.cs]: "/pripadove-studie" as const,
} satisfies LocalizedString;

export function getCaseStudiesPath(tenant: Tenant): string {
	return getPathInLocale(tenant.locale, pathMap);
}
